const ContactInfoIcon = (props) => {
  const { color = 'currentColor' } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 20 20"
      fill="none"
    >
      <mask
        id="mask0_2_985"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="20"
        height="20"
      >
        <rect width="20" height="20" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_2_985)">
        <path
          d="M10 9.74354C9.28126 9.74354 8.67105 9.49271 8.16938 8.99104C7.66757 8.48924 7.41667 7.87896 7.41667 7.16021C7.41667 6.44146 7.66757 5.83125 8.16938 5.32958C8.67105 4.82778 9.28126 4.57687 10 4.57687C10.7188 4.57687 11.329 4.82778 11.8306 5.32958C12.3324 5.83125 12.5833 6.44146 12.5833 7.16021C12.5833 7.87896 12.3324 8.48924 11.8306 8.99104C11.329 9.49271 10.7188 9.74354 10 9.74354ZM4.41667 15.4231V13.9037C4.41667 13.6485 4.49278 13.4025 4.64501 13.1658C4.79723 12.9292 5.01014 12.7243 5.28376 12.5512C6.01014 12.1336 6.77362 11.8134 7.57417 11.5906C8.37473 11.3678 9.18188 11.2565 9.99563 11.2565C10.8094 11.2565 11.618 11.3678 12.4215 11.5906C13.2249 11.8134 13.9899 12.1336 14.7163 12.5512C14.9899 12.7104 15.2028 12.9118 15.355 13.1554C15.5072 13.399 15.5833 13.6485 15.5833 13.9037V15.4231H4.41667ZM5.50001 14.3398H14.5V13.9037C14.5 13.8158 14.4683 13.7331 14.405 13.6556C14.3415 13.5781 14.2541 13.5124 14.1427 13.4583C13.5358 13.0908 12.8801 12.8125 12.1756 12.6233C11.471 12.4343 10.7458 12.3398 10 12.3398C9.25417 12.3398 8.52896 12.4343 7.82438 12.6233C7.11994 12.8125 6.46424 13.0908 5.8573 13.4583C5.74521 13.5353 5.65764 13.609 5.59459 13.6794C5.53153 13.7498 5.50001 13.8246 5.50001 13.9037V14.3398ZM10.0044 8.66021C10.4181 8.66021 10.7708 8.51292 11.0625 8.21833C11.3542 7.92375 11.5 7.56958 11.5 7.15583C11.5 6.74208 11.3527 6.38937 11.0581 6.09771C10.7635 5.80604 10.4094 5.66021 9.99563 5.66021C9.58188 5.66021 9.22917 5.80757 8.93751 6.10229C8.64584 6.39687 8.50001 6.75104 8.50001 7.16479C8.50001 7.5784 8.6473 7.93104 8.94188 8.22271C9.23646 8.51437 9.59063 8.66021 10.0044 8.66021Z"
          fill={color}
        />
      </g>
    </svg>
  );
};

export default ContactInfoIcon;
